import { useState } from "react";
import {
  getAllShopItems,
  getSnakeItems,
  getBackgroungItems,
  getPowerItems,
  getChestItems,
} from "../api/salesApi";

const useShopItems = () => {
  const [allShopItems, setAllShopItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingShopItems, setLoadingShopItems] = useState(false);

  const [snakeItems, setSnakeItems] = useState([]);
  const [loadingSnakeItems, setLoadingSnakeItems] = useState(false);

  const [backgroundItems, setBackgroundItems] = useState([]);
  const [loadingBackgroundItems, setLoadingBackgroundItems] = useState(false);

  const [powerupItems, setPowerupItems] = useState([]);
  const [loadingPowerupItems, setLoadingPowerupItems] = useState(false);

  const [chestItems, setChestItems] = useState([]);
  const [loadingChestItems, setLoadingChestItems] = useState([]);

  const getShopItems = async (page = 1, limit = 10) => {
    try {
      setLoadingShopItems(true);
      const res = await getAllShopItems(page, limit);
      console.log("get all shopitems:", res);
      setAllShopItems(res?.data?.items || []);
      setTotalPages(res?.data?.totalPages || 1);
      return res;
    } catch (error) {
      console.error("error on get all shop items:", error);
    } finally {
      setLoadingShopItems(false);
    }
  };

  const fetchSnakeItems = async (filter) => {
    try {
      setLoadingSnakeItems(true);
      const res = await getSnakeItems(filter);
      console.log("get snake items:", res);
      setSnakeItems(res?.data || []);
      return res;
    } catch (error) {
      console.error("error on get snake items:", error);
    } finally {
      setLoadingSnakeItems(false);
    }
  };

  const fetchBackgroundItems = async (filter) => {
    try {
      setLoadingBackgroundItems(true);
      const res = await getBackgroungItems(filter);
      console.log("get backgroud items:", res);
      setBackgroundItems(res?.data || []);
      return res;
    } catch (error) {
      console.error("error on get background items :", error);
    } finally {
      setLoadingBackgroundItems(false);
    }
  };

  const fetchPower = async () => {
    try {
      setLoadingPowerupItems(true);
      const res = await getPowerItems();
      setPowerupItems(res?.data || []);
      console.log("get prower items:", res);
      return res;
    } catch (error) {
      console.error("error on get power:", error);
    } finally {
      setLoadingPowerupItems(false);
    }
  };

  const fetchChest = async () => {
    try {
      setLoadingChestItems(true);
      const res = await getChestItems();
      setChestItems(res?.data || []);
      console.log("get chest items:", res);
      return res;
    } catch (error) {
      console.error("error on get chest:", error);
    } finally {
      setLoadingChestItems(false);
    }
  };

  return {
    getShopItems,
    allShopItems,
    totalPages,
    loadingShopItems,
    fetchSnakeItems,
    snakeItems,
    loadingSnakeItems,
    fetchBackgroundItems,
    backgroundItems,
    loadingBackgroundItems,
    fetchPower,
    powerupItems,
    loadingPowerupItems,
    fetchChest,
    chestItems,
    loadingChestItems,
  };
};

export default useShopItems;
